import React from 'react'
import { ISummaryCardState } from '../utility/types'
import { IKeyValue } from '@fareye/types'
import { styled } from '@fareye/ui'
import mapComponents from './mapComponents'

interface ISummaryCardProps {
  component?: String,
  isDisabled?: boolean,
  handleClick: () => void
}


const SummaryCardWrapper = styled.div`
	background: #FFFFFF;
	box-sizing: border-box;
	cursor: ${(props: any) => !!props.isDisabled ? 'not-allowed' : 'pointer'};
`

const SummaryCard: React.FC<ISummaryCardProps & ISummaryCardState> = (props) => {
  const { component = "BackgroundSummaryCard", isDisabled = false, handleClick, isSelected, label, count } = props
  console.log(`${label}-`, component)
  const ComponentRender = mapComponents[component as string]
  return (
    <SummaryCardWrapper onClick={() => !isDisabled && handleClick()} isDisabled={isDisabled} {...props}>
      <ComponentRender
        label = {label}
        count = {count}
        isSelected = {isSelected}
      />
    </SummaryCardWrapper>
  )
}

export default SummaryCard